import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// Set worker for pdfjs - using a versioned CDN link
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PDFRenderer = ({ url, currentPage, onDocumentLoadSuccess, zoom, dark }) => {
  const [error, setError] = useState(null);

  return (
    <div className="pdf-renderer-wrapper flex flex-col items-center w-full">
      {error && (
        <div className="p-8 text-center bg-red-500/10 border border-red-500/20 rounded-xl mb-4 w-full max-w-lg">
          <p className="text-red-400 font-medium">Failed to load PDF</p>
          <p className="text-xs text-red-300/60 mt-1">{error.message}</p>
          <button 
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-red-500/20 hover:bg-red-500/30 text-red-200 text-xs rounded-lg transition-colors"
          >
            Retry Loading
          </button>
        </div>
      )}
      
      <Document
        file={url}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={(err) => {
          console.error('PDF Load Error:', err);
          setError(err);
        }}
        loading={
          <div className="flex flex-col items-center justify-center py-20 gap-4">
            <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-accent"></div>
            <span className="text-xs opacity-40 animate-pulse">Initializing PDF engine...</span>
          </div>
        }
      >
        <div style={dark ? { filter: 'invert(0.92) hue-rotate(180deg)' } : undefined}>
          <Page
            pageNumber={currentPage}
            scale={zoom / 100}
            renderAnnotationLayer={false}
            renderTextLayer={true}
            className="shadow-2xl rounded-sm overflow-hidden"
            loading={
              <div className="h-[800px] w-full flex items-center justify-center bg-[#f1f5f9] rounded-xl border border-[#e2e8f0]">
                  <span className="text-sm opacity-20">Rendering page {currentPage}...</span>
              </div>
            }
          />
        </div>
      </Document>
    </div>
  );
};

export default PDFRenderer;
